import { FC, ReactNode } from "react";
import { Container } from "../styles";
import { FlexBox } from "@brg/ui";

export const Layout: FC<{
    title: ReactNode,
    platformOpt: ReactNode;
    categoryOpt: ReactNode;
    categoryList: ReactNode;
    newCategory: ReactNode;
}> = ({
    title,
    platformOpt,
    categoryOpt,
    categoryList,
    newCategory
}) => {

    return (
        <Container>
            {title}
            <FlexBox direction="row" gx={56}>
                <FlexBox direction="column" className="left-side side">
                    {platformOpt}
                    {categoryOpt}
                    {categoryList}
                </FlexBox>
                <FlexBox direction="column" className="right-side side">
                    {newCategory}
                </FlexBox>
            </FlexBox>
        </Container>
    )
}import { FC, ReactNode } from "react";
import { Container } from "../styles";
import { FlexBox } from "@brg/ui";

export const Layout: FC<{
    title: ReactNode,
    platformOpt: ReactNode;
    categoryOpt: ReactNode;
    categoryList: ReactNode;
    newCategory: ReactNode;
}> = ({
    title,
    platformOpt,
    categoryOpt,
    categoryList,
    newCategory
}) => {

    return (
        <Container>
            {title}
            <FlexBox direction="row" gx={56}>
                <FlexBox direction="column" className="left-side side">
                    {platformOpt}
                    {categoryOpt}
                    {categoryList}
                </FlexBox>
                <FlexBox direction="column" className="right-side side">
                    {newCategory}
                </FlexBox>
            </FlexBox>
        </Container>
    )
}